module.exports = __webpack_public_path__ + "static/media/protocol.ef1c3fc5.htm";